{
	"AF": {
		"phone_code": 93,
		"zip_format": "9999"
	},
	"AL": {
		"phone_code": 355,
		"zip_format": "9999"
	},
	"AQ": {
		"phone_code": 672,
		"zip_format": "9999"
	},
	"DZ": {
		"phone_code": 213,
		"zip_format": "99999"
	},
	"AS": {
		"phone_code": 1684,
		"zip_format": "99999"
	},
	"AD": {
		"phone_code": 376,
		"zip_format": "AA999"
	},
	"AO": {
		"phone_code": 244,
		"zip_format": ""
	},
	"AG": {
		"phone_code": 1268,
		"zip_format": "99999"
	},
	"AZ": {
		"phone_code": 994,
		"zip_format": "AA 9999"
	},
	"AR": {
		"phone_code": 54,
		"zip_format": "A9999AAA"
	},
	"AU": {
		"phone_code": 61,
		"zip_format": "9999"
	},
	"AT": {
		"phone_code": 43,
		"zip_format": "9999"
	},
	"BS": {
		"phone_code": 1242,
		"zip_format": ""
	},
	"BH": {
		"phone_code": 973,
		"zip_format": "9999"
	},
	"BD": {
		"phone_code": 880,
		"zip_format": "9999"
	},
	"AM": {
		"phone_code": 374,
		"zip_format": "9999"
	},
	"BB": {
		"phone_code": 1246,
		"zip_format": "AA99999"
	},
	"BE": {
		"phone_code": 32,
		"zip_format": "9999"
	},
	"BM": {
		"phone_code": 1441,
		"zip_format": "AA 99"
	},
	"BT": {
		"phone_code": 975,
		"zip_format": "99999"
	},
	"BO": {
		"phone_code": 591,
		"zip_format": ""
	},
	"BA": {
		"phone_code": 387,
		"zip_format": "99999"
	},
	"BW": {
		"phone_code": 267,
		"zip_format": ""
	},
	"BV": {
		"phone_code": 55,
		"zip_format": ""
	},
	"BR": {
		"phone_code": 55,
		"zip_format": "99999-999"
	},
	"BZ": {
		"phone_code": 501,
		"zip_format": ""
	},
	"IO": {
		"phone_code": 246,
		"zip_format": "AA9A 9AA"
	},
	"SB": {
		"phone_code": 677,
		"zip_format": ""
	},
	"VG": {
		"phone_code": 1284,
		"zip_format": "AA9999"
	},
	"BN": {
		"phone_code": 673,
		"zip_format": "AA9999"
	},
	"BG": {
		"phone_code": 359,
		"zip_format": "9999"
	},
	"MM": {
		"phone_code": 95,
		"zip_format": "99999"
	},
	"BI": {
		"phone_code": 257,
		"zip_format": ""
	},
	"BY": {
		"phone_code": 375,
		"zip_format": "999999"
	},
	"KH": {
		"phone_code": 855,
		"zip_format": "99999"
	},
	"CM": {
		"phone_code": 237,
		"zip_format": ""
	},
	"CA": {
		"phone_code": 1,
		"zip_format": "A9A 9A9"
	},
	"CV": {
		"phone_code": 238,
		"zip_format": "9999"
	},
	"KY": {
		"phone_code": 1345,
		"zip_format": "AA9-9999"
	},
	"CF": {
		"phone_code": 236,
		"zip_format": ""
	},
	"LK": {
		"phone_code": 94,
		"zip_format": "99999"
	},
	"TD": {
		"phone_code": 235,
		"zip_format": "99999"
	},
	"CL": {
		"phone_code": 56,
		"zip_format": "9999999"
	},
	"CN": {
		"phone_code": 86,
		"zip_format": "999999"
	},
	"TW": {
		"phone_code": 886,
		"zip_format": "99999"
	},
	"CX": {
		"phone_code": 61,
		"zip_format": "9999"
	},
	"CC": {
		"phone_code": 61,
		"zip_format": "9999 A9"
	},
	"CO": {
		"phone_code": 57,
		"zip_format": "999999"
	},
	"KM": {
		"phone_code": 269,
		"zip_format": ""
	},
	"YT": {
		"phone_code": 262,
		"zip_format": "99999"
	},
	"CG": {
		"phone_code": 242,
		"zip_format": ""
	},
	"CD": {
		"phone_code": 243,
		"zip_format": ""
	},
	"CK": {
		"phone_code": 682,
		"zip_format": ""
	},
	"CR": {
		"phone_code": 506,
		"zip_format": "99999"
	},
	"HR": {
		"phone_code": 385,
		"zip_format": "99999"
	},
	"CU": {
		"phone_code": 53,
		"zip_format": "99999"
	},
	"CY": {
		"phone_code": 357,
		"zip_format": "9999"
	},
	"CZ": {
		"phone_code": 420,
		"zip_format": "999 99"
	},
	"BJ": {
		"phone_code": 229,
		"zip_format": ""
	},
	"DK": {
		"phone_code": 45,
		"zip_format": "9999"
	},
	"DM": {
		"phone_code": 1767,
		"zip_format": ""
	},
	"DO": {
		"phone_code": 1809,
		"zip_format": "99999"
	},
	"EC": {
		"phone_code": 593,
		"zip_format": "999999"
	},
	"SV": {
		"phone_code": 503,
		"zip_format": "9999"
	},
	"GQ": {
		"phone_code": 240,
		"zip_format": ""
	},
	"ET": {
		"phone_code": 251,
		"zip_format": "9999"
	},
	"ER": {
		"phone_code": 291,
		"zip_format": ""
	},
	"EE": {
		"phone_code": 372,
		"zip_format": "99999"
	},
	"FO": {
		"phone_code": 298,
		"zip_format": "999"
	},
	"FK": {
		"phone_code": 500,
		"zip_format": "AAAA 9AA"
	},
	"GS": {
		"phone_code": 500,
		"zip_format": "AAAA 9AA"
	},
	"FJ": {
		"phone_code": 679,
		"zip_format": ""
	},
	"FI": {
		"phone_code": 358,
		"zip_format": "99999"
	},
	"AX": {
		"phone_code": 358,
		"zip_format": "99999"
	},
	"FR": {
		"phone_code": 33,
		"zip_format": "99999"
	},
	"GF": {
		"phone_code": 594,
		"zip_format": "99999"
	},
	"PF": {
		"phone_code": 689,
		"zip_format": "99999"
	},
	"DJ": {
		"phone_code": 253,
		"zip_format": ""
	},
	"GA": {
		"phone_code": 241,
		"zip_format": ""
	},
	"GE": {
		"phone_code": 995,
		"zip_format": "9999"
	},
	"GM": {
		"phone_code": 220,
		"zip_format": ""
	},
	"PS": {
		"phone_code": 970,
		"zip_format": "999-999"
	},
	"DE": {
		"phone_code": 49,
		"zip_format": "99999"
	},
	"GH": {
		"phone_code": 233,
		"zip_format": ""
	},
	"GI": {
		"phone_code": 350,
		"zip_format": "AA99 9AA"
	},
	"KI": {
		"phone_code": 686,
		"zip_format": ""
	},
	"GR": {
		"phone_code": 30,
		"zip_format": "999 99"
	},
	"GL": {
		"phone_code": 299,
		"zip_format": "9999"
	},
	"GD": {
		"phone_code": 1473,
		"zip_format": ""
	},
	"GP": {
		"phone_code": 590,
		"zip_format": "99999"
	},
	"GU": {
		"phone_code": 1671,
		"zip_format": "99999"
	},
	"GT": {
		"phone_code": 502,
		"zip_format": "99999"
	},
	"GN": {
		"phone_code": 224,
		"zip_format": "999"
	},
	"GY": {
		"phone_code": 592,
		"zip_format": ""
	},
	"HT": {
		"phone_code": 509,
		"zip_format": "9999"
	},
	"VA": {
		"phone_code": 39,
		"zip_format": "999"
	},
	"HN": {
		"phone_code": 504,
		"zip_format": ""
	},
	"HK": {
		"phone_code": 852,
		"zip_format": "999999"
	},
	"HU": {
		"phone_code": 36,
		"zip_format": "9999"
	},
	"IS": {
		"phone_code": 354,
		"zip_format": "999"
	},
	"IN": {
		"phone_code": 91,
		"zip_format": "999999"
	},
	"ID": {
		"phone_code": 62,
		"zip_format": "99999"
	},
	"IR": {
		"phone_code": 98,
		"zip_format": "99999"
	},
	"IQ": {
		"phone_code": 964,
		"zip_format": "99999"
	},
	"IE": {
		"phone_code": 353,
		"zip_format": ""
	},
	"IL": {
		"phone_code": 972,
		"zip_format": "9999999"
	},
	"IT": {
		"phone_code": 39,
		"zip_format": "99999"
	},
	"CI": {
		"phone_code": 225,
		"zip_format": ""
	},
	"JM": {
		"phone_code": 1876,
		"zip_format": "AAAAA99"
	},
	"JP": {
		"phone_code": 81,
		"zip_format": "999-9999"
	},
	"KZ": {
		"phone_code": 7,
		"zip_format": "999999"
	},
	"JO": {
		"phone_code": 962,
		"zip_format": "99999"
	},
	"KE": {
		"phone_code": 254,
		"zip_format": "99999"
	},
	"KP": {
		"phone_code": 850,
		"zip_format": ""
	},
	"KR": {
		"phone_code": 82,
		"zip_format": "99999"
	},
	"KW": {
		"phone_code": 965,
		"zip_format": "99999"
	},
	"KG": {
		"phone_code": 996,
		"zip_format": "999999"
	},
	"LA": {
		"phone_code": 856,
		"zip_format": "99999"
	},
	"LB": {
		"phone_code": 961,
		"zip_format": "9999"
	},
	"LS": {
		"phone_code": 266,
		"zip_format": "999"
	},
	"LV": {
		"phone_code": 371,
		"zip_format": "AA-9999"
	},
	"LR": {
		"phone_code": 231,
		"zip_format": "9999"
	},
	"LY": {
		"phone_code": 218,
		"zip_format": "99999"
	},
	"LI": {
		"phone_code": 423,
		"zip_format": "9999"
	},
	"LT": {
		"phone_code": 370,
		"zip_format": "99999"
	},
	"LU": {
		"phone_code": 352,
		"zip_format": "9999"
	},
	"MO": {
		"phone_code": 853,
		"zip_format": "999999"
	},
	"MG": {
		"phone_code": 261,
		"zip_format": "999"
	},
	"MW": {
		"phone_code": 265,
		"zip_format": ""
	},
	"MY": {
		"phone_code": 60,
		"zip_format": "99999"
	},
	"MV": {
		"phone_code": 960,
		"zip_format": "99999"
	},
	"ML": {
		"phone_code": 223,
		"zip_format": ""
	},
	"MT": {
		"phone_code": 356,
		"zip_format": "AAA 9999"
	},
	"MQ": {
		"phone_code": 596,
		"zip_format": "99999"
	},
	"MR": {
		"phone_code": 222,
		"zip_format": ""
	},
	"MU": {
		"phone_code": 230,
		"zip_format": "A9999"
	},
	"MX": {
		"phone_code": 52,
		"zip_format": "99999"
	},
	"MC": {
		"phone_code": 377,
		"zip_format": "99999"
	},
	"MN": {
		"phone_code": 976,
		"zip_format": "99999"
	},
	"MD": {
		"phone_code": 373,
		"zip_format": "9999"
	},
	"ME": {
		"phone_code": 382,
		"zip_format": "99999"
	},
	"MS": {
		"phone_code": 1664,
		"zip_format": "AAA9999"
	},
	"MA": {
		"phone_code": 212,
		"zip_format": "99999"
	},
	"MZ": {
		"phone_code": 258,
		"zip_format": "9999"
	},
	"OM": {
		"phone_code": 968,
		"zip_format": "999"
	},
	"NA": {
		"phone_code": 264,
		"zip_format": ""
	},
	"NR": {
		"phone_code": 674,
		"zip_format": ""
	},
	"NP": {
		"phone_code": 977,
		"zip_format": "99999"
	},
	"NL": {
		"phone_code": 31,
		"zip_format": "9999 AA"
	},
	"CW": {
		"phone_code": 599,
		"zip_format": "9999 AA"
	},
	"AW": {
		"phone_code": 297,
		"zip_format": "9999 AA"
	},
	"SX": {
		"phone_code": 1721,
		"zip_format": "9999 AA"
	},
	"NC": {
		"phone_code": 687,
		"zip_format": "99999"
	},
	"VU": {
		"phone_code": 678,
		"zip_format": ""
	},
	"NZ": {
		"phone_code": 64,
		"zip_format": "9999"
	},
	"NI": {
		"phone_code": 505,
		"zip_format": "99999"
	},
	"NE": {
		"phone_code": 227,
		"zip_format": "9999"
	},
	"NG": {
		"phone_code": 234,
		"zip_format": "999999"
	},
	"NU": {
		"phone_code": 683,
		"zip_format": ""
	},
	"NF": {
		"phone_code": 672,
		"zip_format": "9999"
	},
	"NO": {
		"phone_code": 47,
		"zip_format": "9999"
	},
	"MP": {
		"phone_code": 1670,
		"zip_format": "99999"
	},
	"UM": {
		"phone_code": 246,
		"zip_format": null
	},
	"FM": {
		"phone_code": 691,
		"zip_format": "99999"
	},
	"MH": {
		"phone_code": 692,
		"zip_format": "99999"
	},
	"PW": {
		"phone_code": 680,
		"zip_format": "99999"
	},
	"PK": {
		"phone_code": 92,
		"zip_format": "99999"
	},
	"PA": {
		"phone_code": 507,
		"zip_format": ""
	},
	"PG": {
		"phone_code": 675,
		"zip_format": "999"
	},
	"PY": {
		"phone_code": 595,
		"zip_format": "9999"
	},
	"PE": {
		"phone_code": 51,
		"zip_format": "99999"
	},
	"PH": {
		"phone_code": 63,
		"zip_format": "9999"
	},
	"PN": {
		"phone_code": 870,
		"zip_format": "AAA9 9AA"
	},
	"PL": {
		"phone_code": 48,
		"zip_format": "99-999"
	},
	"PT": {
		"phone_code": 351,
		"zip_format": "9999-999"
	},
	"GW": {
		"phone_code": 245,
		"zip_format": "9999"
	},
	"TL": {
		"phone_code": 670,
		"zip_format": ""
	},
	"PR": {
		"phone_code": 1,
		"zip_format": "99999"
	},
	"QA": {
		"phone_code": 974,
		"zip_format": ""
	},
	"RE": {
		"phone_code": 262,
		"zip_format": "99999"
	},
	"RO": {
		"phone_code": 40,
		"zip_format": "999999"
	},
	"RU": {
		"phone_code": 7,
		"zip_format": "999999"
	},
	"RW": {
		"phone_code": 250,
		"zip_format": ""
	},
	"BL": {
		"phone_code": 590,
		"zip_format": "99999"
	},
	"SH": {
		"phone_code": 290,
		"zip_format": "AAAA 9AA"
	},
	"KN": {
		"phone_code": 1869,
		"zip_format": ""
	},
	"AI": {
		"phone_code": 1264,
		"zip_format": "AA-9999"
	},
	"LC": {
		"phone_code": 1758,
		"zip_format": ""
	},
	"PM": {
		"phone_code": 508,
		"zip_format": "99999"
	},
	"VC": {
		"phone_code": 1784,
		"zip_format": "AA9999"
	},
	"SM": {
		"phone_code": 378,
		"zip_format": "99999"
	},
	"ST": {
		"phone_code": 239,
		"zip_format": ""
	},
	"SA": {
		"phone_code": 966,
		"zip_format": "99999-9999"
	},
	"SN": {
		"phone_code": 221,
		"zip_format": "99999"
	},
	"RS": {
		"phone_code": 381,
		"zip_format": "99999"
	},
	"SC": {
		"phone_code": 248,
		"zip_format": ""
	},
	"SL": {
		"phone_code": 232,
		"zip_format": ""
	},
	"SG": {
		"phone_code": 65,
		"zip_format": "999999"
	},
	"SK": {
		"phone_code": 421,
		"zip_format": "999 99"
	},
	"VN": {
		"phone_code": 84,
		"zip_format": "999999"
	},
	"SI": {
		"phone_code": 386,
		"zip_format": "9999"
	},
	"SO": {
		"phone_code": 252,
		"zip_format": ""
	},
	"ZA": {
		"phone_code": 27,
		"zip_format": "9999"
	},
	"ZW": {
		"phone_code": 263,
		"zip_format": ""
	},
	"ES": {
		"phone_code": 34,
		"zip_format": "99999"
	},
	"SS": {
		"phone_code": 211,
		"zip_format": "99999"
	},
	"EH": {
		"phone_code": 212,
		"zip_format": "99999"
	},
	"SD": {
		"phone_code": 249,
		"zip_format": "99999"
	},
	"SR": {
		"phone_code": 597,
		"zip_format": ""
	},
	"SJ": {
		"phone_code": 47,
		"zip_format": "9999"
	},
	"SZ": {
		"phone_code": 268,
		"zip_format": "A999"
	},
	"SE": {
		"phone_code": 46,
		"zip_format": "999 99"
	},
	"CH": {
		"phone_code": 41,
		"zip_format": "9999"
	},
	"SY": {
		"phone_code": 963,
		"zip_format": ""
	},
	"TJ": {
		"phone_code": 992,
		"zip_format": "999"
	},
	"TH": {
		"phone_code": 66,
		"zip_format": "99999"
	},
	"TG": {
		"phone_code": 228,
		"zip_format": ""
	},
	"TK": {
		"phone_code": 690,
		"zip_format": ""
	},
	"TO": {
		"phone_code": 676,
		"zip_format": ""
	},
	"TT": {
		"phone_code": 1868,
		"zip_format": ""
	},
	"AE": {
		"phone_code": 971,
		"zip_format": ""
	},
	"TN": {
		"phone_code": 216,
		"zip_format": "9999"
	},
	"TR": {
		"phone_code": 90,
		"zip_format": "99999"
	},
	"TM": {
		"phone_code": 993,
		"zip_format": "999999"
	},
	"TC": {
		"phone_code": 1649,
		"zip_format": "AAAA 9AA"
	},
	"TV": {
		"phone_code": 688,
		"zip_format": ""
	},
	"UG": {
		"phone_code": 256,
		"zip_format": ""
	},
	"UA": {
		"phone_code": 380,
		"zip_format": "99999"
	},
	"MK": {
		"phone_code": 389,
		"zip_format": "9999"
	},
	"EG": {
		"phone_code": 20,
		"zip_format": "99999"
	},
	"GB": {
		"phone_code": 44,
		"zip_format": "AA9 9AA"
	},
	"GG": {
		"phone_code": 44,
		"zip_format": "AA9 9AA"
	},
	"JE": {
		"phone_code": 44,
		"zip_format": "AA9 9AA"
	},
	"IM": {
		"phone_code": 44,
		"zip_format": "AA99 9AA"
	},
	"TZ": {
		"phone_code": 255,
		"zip_format": ""
	},
	"US": {
		"phone_code": 1,
		"zip_format": "99999?9999"
	},
	"VI": {
		"phone_code": 1340,
		"zip_format": "99999"
	},
	"BF": {
		"phone_code": 226,
		"zip_format": ""
	},
	"UY": {
		"phone_code": 598,
		"zip_format": "99999"
	},
	"UZ": {
		"phone_code": 998,
		"zip_format": "999999"
	},
	"VE": {
		"phone_code": 58,
		"zip_format": "9999"
	},
	"WF": {
		"phone_code": 681,
		"zip_format": "99999"
	},
	"WS": {
		"phone_code": 685,
		"zip_format": "99999"
	},
	"YE": {
		"phone_code": 967,
		"zip_format": ""
	},
	"ZM": {
		"phone_code": 260,
		"zip_format": "99999"
	}
}
